import * as _ from "lodash-es";
import { ParseResult } from "papaparse";
import { ChangeEvent, Component } from "react";
import "./BulkOrderModal.scss";
import IBulkOrderImportDTO from "@models/DTO/IBulkOrderImportDTO";
import IBulkOrderImportProgressDTO from "@models/DTO/IBulkOrderImportProgressDTO";
import IBulkOrderImportStartDTO from "@models/DTO/IBulkOrderImportStartDTO";
import IErrorDTO from "@models/DTO/IErrorDTO";
import IGetOrderBatchPdfDTO from "@models/DTO/IGetOrderBatchPdfDTO";
import IOnBulkOrderImportDTO from "@models/DTO/IOnBulkOrderImportDTO";
import IOnGetOrderBatchPdfDTO from "@models/DTO/IOnGetOrderBatchPdfDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IBulkImportOrderRow from "@models/IBulkImportOrderRow";
import IBulkOrderImportRowUI from "@models/IBulkOrderImportRowUI";
import IOrder_Batch from "@models/IOrder_Batch";
import ISupplierModel from "@models/ISupplierModel";
import IUserUI from "@models/IUserUI";
import OwButton from "@components/shared/OwButton/OwButton";
import OwCheckbox from "@components/shared/OwCheckbox/OwCheckbox";
import OwCsvReader from "@components/shared/OwCsvReader/OwCsvReader";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import IOnGetSignedUrlDTO from "@models/DTO/IOnGetSignedUrlDTO";
import IOnCreateFileUploadDTO from "@models/DTO/IOnCreateFileUploadDTO";
import IGetSignedUrlDTO from "@models/DTO/IGetSignedUrlDTO";
import ICreateFileUploadDTO from "@models/DTO/ICreateFileUploadDTO";
import FileUploadResourceTypeEnum from "@models/FileUploadResourceTypeEnum";
import axios, { AxiosProgressEvent, AxiosRequestConfig } from "axios";
import AttachmentTypeEnum from "@models/AttachmentTypeEnum";
import S3UploadTypeEnum from "@models/S3UploadTypeEnum";
import OwS3Uploader from "@components/shared/OwS3Uploader/OwS3Uploader";
import OwRadioSelect from "@components/shared/OwRadioSelect/OwRadioSelect";
import IOwRadioSelectOption from "@models/IOwRadioSelectOption";
import { Socket } from "socket.io-client";
import SupplierGuidEnum from "@models/SupplierGuidEnum";
import IUiSocketSetup from "@models/IUiSocketSetup";

type Props = {
    closeModalFn: (refreshData?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    fileDropRejected: boolean;
    fileTypeRejected: boolean;
    file?: any;
    contentType?: string;
    isProcessing: boolean;
    upload_type?: string;
    uploadActive: boolean;
    csvData?: ParseResult<IBulkOrderImportRowUI>;
    isFormValid: boolean;
    showResults: boolean;
    auto_submit_orders: boolean;
    recordsUpdated: number;
    recordsCreated: number;
    recordsNotUpdated: number;
    recordsErrored: number;
    totalRecords: number;
    doOrdersRefresh: boolean;
    currentTotal: number;
    currentProgress: number;
    progress: number;
    erroredRecords: { sequence: number; error: string }[];
    orderBatchModel?: IOrder_Batch;
    bulkOrdersCsvFile: any;
    progressTotal: number;
    progressChunk: number;
    progressPerc: number;
    showBulkUploader: boolean;
};

class BulkOrderModal extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.state = {
            fileDropRejected: false,
            fileTypeRejected: false,
            isFormValid: false,
            isProcessing: false,
            auto_submit_orders: true,
            recordsCreated: 0,
            recordsErrored: 0,
            recordsNotUpdated: 0,
            recordsUpdated: 0,
            showResults: false,
            totalRecords: 0,
            uploadActive: false,
            doOrdersRefresh: false,
            currentTotal: 0,
            currentProgress: 0,
            progress: 0,
            erroredRecords: [],
            bulkOrdersCsvFile: null,
            progressTotal: 0,
            progressChunk: 0,
            progressPerc: 0,
            showBulkUploader:
                this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ||
                this.props.supplierModel.guid === SupplierGuidEnum.ROCKY_TOP_DELIGHTS,
        };

        this.sockets = [
            {
                endpoint: EndpointsEnum.Notify,
                fn: this.notify,
            },
            {
                endpoint: EndpointsEnum.OrderOnBulkOrderImport,
                fn: this.onBulkOrderImport,
            },
            {
                endpoint: EndpointsEnum.OrderBulkOrderImportStart,
                fn: this.bulkOrderImportStart,
            },
            {
                endpoint: EndpointsEnum.OrderBulkOrderImportProgress,
                fn: this.bulkOrderImportProgress,
            },
            {
                endpoint: EndpointsEnum.OrderOnGetOrderBatchPDF,
                fn: this.onGetOrderBatchPdf,
            },
            {
                endpoint: EndpointsEnum.FileUploadOnGetSignedUrl,
                fn: this.onGetSignedUrl,
            },
            {
                endpoint: EndpointsEnum.FileUploadOnCreateFileUpload,
                fn: this.onCreateFileUpload,
            },
        ];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getSignedUrl = () => {
        const payload: IGetSignedUrlDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            resourceType: FileUploadResourceTypeEnum.bulkOrdersCsv,
            file: {
                name: this.state.bulkOrdersCsvFile.name,
                type: this.state.bulkOrdersCsvFile.type,
            },
        };

        this.props.socket.emit(EndpointsEnum.FileUploadGetSignedUrl, payload);
    };

    onGetSignedUrl = async (data: IOnGetSignedUrlDTO) => {
        if (this.state.bulkOrdersCsvFile) {
            const config: AxiosRequestConfig = {
                headers: {
                    "Content-Type": this.state.bulkOrdersCsvFile.type,
                },
                onUploadProgress: (progressEvent: AxiosProgressEvent) => {
                    if (progressEvent.total) {
                        // this.onUploadProgress(progressEvent);
                        const progressPerc = (progressEvent.loaded / progressEvent.total) * 100;

                        const progressTotal = Number((progressEvent.total / 1048576).toFixed(2));

                        const progressChunk = Number((progressEvent.loaded / 1048576).toFixed(2));

                        this.setState({
                            progressTotal,
                            progressChunk,
                            progressPerc,
                        });
                    }
                },
            };

            const res = await axios.put(data.signedUrl, this.state.bulkOrdersCsvFile, config);

            const createFileUploadData: ICreateFileUploadDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                name: data.name,
                url: data.url,
                bucket: data.bucket,
                key: data.key,
                eTag: res.headers.etag,
                size: this.state.bulkOrdersCsvFile.size,
                attachment_type_id: AttachmentTypeEnum.zip,
                s3_upload_type: S3UploadTypeEnum.BULK_ORDERS_CSV,
                is_s3_upload: true,
            };

            this.createFileUpload(createFileUploadData);
        }
    };

    createFileUpload = (data: ICreateFileUploadDTO) => {
        this.props.socket.emit(EndpointsEnum.FileUploadCreateFileUpload, data);
    };

    onCreateFileUpload = (data: IOnCreateFileUploadDTO) => {
        this.setState({
            uploadActive: false,
        });
    };

    bulkOrderImportStart = (data: IBulkOrderImportStartDTO) => {
        this.setState({
            currentProgress: 0,
            progress: 0,
            currentTotal: data.totalItems,
            erroredRecords: [],
        });
    };

    bulkOrderImportProgress = (data: IBulkOrderImportProgressDTO) => {
        const progress = (Number(data.totalProcessed) / Number(data.totalItems)) * 100;

        this.setState({
            currentProgress: data.totalProcessed,
            progress,
        });
    };

    notify = (data: IErrorDTO) => {
        this.setState({
            uploadActive: false,
        });
    };

    closeModal = () => {
        this.props.closeModalFn(this.state.doOrdersRefresh);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    resetUploader = () => {
        this.setState({
            fileDropRejected: false,
            fileTypeRejected: false,
            isFormValid: false,
            isProcessing: false,
            auto_submit_orders: true,
            recordsCreated: 0,
            recordsErrored: 0,
            recordsNotUpdated: 0,
            recordsUpdated: 0,
            showResults: false,
            totalRecords: 0,
            uploadActive: false,
            doOrdersRefresh: false,
            currentTotal: 0,
            currentProgress: 0,
            progress: 0,
            erroredRecords: [],
            file: "",
            csvData: undefined,
        });
    };

    doUpload = () => {
        this.setState(
            {
                uploadActive: true,
            },
            () => {
                let vendorName = "vendor";

                if (this.props.supplierModel.vendor_name_override) {
                    vendorName = this.props.supplierModel.vendor_name_override;
                }

                vendorName = _.upperFirst(vendorName);

                const rows = this.state.csvData?.data.map((dataRow) => {
                    const rowDetail: IBulkImportOrderRow = {
                        address_line_one: dataRow["Address Line One"],
                        address_line_three: dataRow["Address Line Three"],
                        address_line_two: dataRow["Address Line Two"],
                        city: dataRow.City,
                        country: dataRow.Country,
                        // @ts-expect-error
                        customer: dataRow[vendorName],
                        end_client: dataRow["End Client"],
                        end_client_address_line_one: dataRow["End Client Address Line One"],
                        end_client_address_line_three: dataRow["End Client Address Line Three"],
                        end_client_address_line_two: dataRow["End Client Address Line Two"],
                        end_client_city: dataRow["End Client City"],
                        end_client_country: dataRow["End Client Country"],
                        end_client_postal_code: dataRow["End Client Postal Code"],
                        end_client_state: dataRow["End Client State"],
                        expedited: dataRow.Expedited ? Number(dataRow.Expedited) : undefined,
                        postal_code: dataRow["Postal Code"],
                        service_level: dataRow["Service Level"],
                        state: dataRow.State,
                        third_party_order_ref: dataRow["Third Party Order Ref."],
                        qty: Number(dataRow.Qty),
                        sku: dataRow.SKU || dataRow.Item || "",
                        sequence: Number(dataRow.Sequence),
                        price_group: dataRow["Price Group"],
                        catalog: dataRow.Catalog,
                        note: dataRow.Note || "",
                        internal_note: dataRow["Internal Note"],
                        order_date: dataRow["Order Date"],
                        ship_date: dataRow["Ship Date"],
                        unit_price: dataRow["Unit Price"],
                    };

                    if (!_.isString(this.props.supplierModel.settings) && this.props.supplierModel.settings.order_details) {
                        for (const order_detail of this.props.supplierModel.settings.order_details) {
                            const title = _.startCase(order_detail);

                            // @ts-expect-error
                            if (dataRow[title]) {
                                // @ts-expect-error
                                rowDetail[order_detail] = dataRow[title];
                            }
                        }
                    }

                    return rowDetail;
                });

                const payload: IBulkOrderImportDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    rows: JSON.stringify(rows),
                    autoSubmitOrders: this.state.auto_submit_orders,
                };

                this.props.socket.emit(EndpointsEnum.OrderBulkOrderImport, payload);

                // this.processUploadType();
            }
        );
    };

    onBulkOrderImport = (data: IOnBulkOrderImportDTO) => {
        this.setState({
            uploadActive: false,
            showResults: true,
            // recordsUpdated: 0,
            // orderBatchModel: data.orderBatchModel,
            // totalRecords: data.totalProcessed,
            // recordsCreated: data.totalCreated,
            // recordsNotUpdated: 0,
            // recordsErrored: data.totalErrored,
            csvData: undefined,
            doOrdersRefresh: true,
            // erroredRecords: data.erroredSequences,
        });
    };

    csvLoaded = (csvData?: ParseResult<IBulkOrderImportRowUI>) => {
        console.log(csvData);
        if (csvData) {
            this.setState(
                {
                    csvData,
                },
                () => {
                    // this.isFormValid();
                }
            );
        }
    };

    resetResults = () => {
        this.setState({
            showResults: false,
            recordsUpdated: 0,
            totalRecords: 0,
            recordsCreated: 0,
            recordsNotUpdated: 0,
        });
    };

    downloadBatchPdf = () => {
        if (this.state.orderBatchModel) {
            const payload: IGetOrderBatchPdfDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderBatchGuid: this.state.orderBatchModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.OrderGetOrderBatchPDF, payload);
        }
    };

    onGetOrderBatchPdf = (data: IOnGetOrderBatchPdfDTO) => {
        const blob = new Blob([data.pdfData], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const fileName = data.filename;

        link.download = _.get(this.props, "fileName", `${fileName}.pdf`);
        link.click();
    };

    handleUploadTypeChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        let showBulkUploader = false;

        if (value === "bulk_uploader") {
            showBulkUploader = true;
        }

        this.setState({
            showBulkUploader,
        });
    };

    render() {
        const uploadOptions: IOwRadioSelectOption[] = [
            {
                label: "Bulk Uploader (More than 100 records)",
                value: "bulk_uploader",
            },
        ];

        switch (this.props.supplierModel.guid) {
            case SupplierGuidEnum.VERMONT:
            case SupplierGuidEnum.ROCKY_TOP_DELIGHTS:
                break;

            default:
                uploadOptions.push({
                    label: "Basic Uploader",
                    value: "basic_uploader",
                });
                break;
        }

        return (
            <div className="BulkOrderModal standardModal p-2">
                <div className={"w-100 h-2r"}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_csv"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>
                <div className={"w-100"}>
                    {this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? null : (
                        <div className={"col-12 mt-4"}>
                            <OwRadioSelect options={uploadOptions} name={"bulk_upload"} fn={this.handleUploadTypeChange} />
                        </div>
                    )}
                    <div className={"col-12 mt-4"}>
                        {this.state.showBulkUploader ? (
                            <OwS3Uploader
                                resourceType={FileUploadResourceTypeEnum.bulkOrdersCsv}
                                socket={this.props.socket}
                                isReadOnly={false}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                isS3Upload={true}
                                s3UploadType={S3UploadTypeEnum.BULK_ORDERS_CSV}
                            />
                        ) : (
                            <div className={"drop-area"}>
                                <OwCsvReader onFileLoaded={this.csvLoaded} isProcessing={this.state.isProcessing} value={this.state.file} />
                            </div>
                        )}

                        <div>
                            {this.state.file ? (
                                <div>
                                    <OwLabel title={"loaded_file"} noBottomMargin={true} isBold={true} isUnderline={true} />:{" "}
                                    {this.state.file.name}
                                </div>
                            ) : null}
                            <div className={"d-flex justify-content-between error-section"}>
                                <OwLabel
                                    className={"text-danger mt-2 " + (this.state.fileDropRejected ? "" : "d-none")}
                                    title={"file_drop_rejected_too_big"}
                                />
                                <OwLabel
                                    className={"text-danger mt-2 " + (this.state.fileTypeRejected ? "" : "d-none")}
                                    title={"file_type_invalid"}
                                />
                            </div>
                        </div>
                    </div>

                    {this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? null : (
                        <div>
                            <div className={"col-12 mt-4"}>
                                <OwCheckbox
                                    fn={this.handleChange}
                                    name={"auto_submit_orders"}
                                    label={"auto_submit_orders"}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={this.state.auto_submit_orders}
                                />
                            </div>

                            <div className={"col-12 mt-4"}>
                                {this.state.showResults ? (
                                    <OwButton title={"upload_another"} fn={this.resetUploader} />
                                ) : (
                                    <OwButton
                                        title={"upload"}
                                        fn={this.doUpload}
                                        active={this.state.uploadActive}
                                        disabled={!this.state.csvData}
                                        disableOnActive={true}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {this.state.showResults ? (
                    <div className={"col-12"}>
                        <div>
                            <OwLabel title={"successfully_uploaded_batch_order_csv"} />
                        </div>
                        <div>
                            <OwLabel title={"allow_up_to_one_min_for_processing"} />
                        </div>
                        <div>
                            <OwLabel title={"an_email_will_be_sent_once_processed"} />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default BulkOrderModal;
